import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cart-checkout__reject" };
const _hoisted_2 = { class: "mb-2 mt-3" };
const _hoisted_3 = { class: "mb-4 data-box" };
const _hoisted_4 = { class: "item" };
const _hoisted_5 = { style: { "margin-top": "8px" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_area = _resolveComponent("g-text-area");
    const _component_g_form = _resolveComponent("g-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_g_form, {
            ref: "frmMain",
            "data-object": _ctx.data
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.CommentForReject')), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Commen')), 1),
                        _createElementVNode("div", null, [
                            _createVNode(_component_g_text_area, {
                                "data-member": "rejectNote",
                                rows: 10
                            })
                        ])
                    ])
                ])
            ]),
            _: 1
        }, 8, ["data-object"])
    ]));
}
